import React from 'react';
import { Editor, EditorState, ContentState } from 'draft-js';

import VideoPlayer from 'Shared/components/VideoPlayer/VideoPlayer';
import { FeedbackRecognitionType, FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

import FeedbackFromReviewTemplateTemplateContext from './FeedbackFromReviewTemplateTemplateContext';

import './FeedbackContent.scss';

type Props = {
  feedbackItem: FeedbackRecognitionType;
};

function FeedbackContent({
  feedbackItem: {
    likeThatText,
    likeThatVideo,
    wishThatText,
    wishThatVideo,
    templateType,
    reviewTemplateSlug,
    answers,
    uuid,
  },
}: Props) {
  const isLikeThatWishThatTemplate = templateType === FeedbackRecognitionTemplateTypes.feedbackLikeThatWishThatTemplate;

  const isStrengthsOpportunitiesTemplate =
    templateType === FeedbackRecognitionTemplateTypes.feedbackStrengthsOpportunitiesTemplate;

  return (
    <div className="feedback-item-content d-flex flex-column p-3">
      {templateType === FeedbackRecognitionTemplateTypes.feedbackfromReviewTemplateTemplate && (
        <FeedbackFromReviewTemplateTemplateContext
          uuid={uuid}
          answers={answers}
          reviewTemplateSlug={reviewTemplateSlug}
        />
      )}
      {likeThatText || likeThatVideo ? (
        <div className="feedback-item-content-section">
          <div className="feedback-item-content-section-header">
            {isLikeThatWishThatTemplate && <b>I like that you...</b>}
            {isStrengthsOpportunitiesTemplate && <b>Strengths</b>}
          </div>
          {likeThatText && (
            <Editor editorState={EditorState.createWithContent(ContentState.createFromText(likeThatText))} readOnly />
          )}
          {likeThatVideo && (
            <VideoPlayer
              videoID={likeThatVideo.id}
              sources={[likeThatVideo.mp4Url, likeThatVideo.url]}
              previewImageURL={likeThatVideo.previewImageUrl}
              transcription={likeThatVideo.transcription}
              audioOnly={likeThatVideo.audioOnly}
            />
          )}
        </div>
      ) : null}
      {wishThatText || wishThatVideo ? (
        <div className="feedback-item-content-section mt-3">
          <div className="feedback-item-content-section-header">
            {isLikeThatWishThatTemplate && <b>I wish that you...</b>}
            {isStrengthsOpportunitiesTemplate && <b>Opportunities for improvement</b>}
          </div>
          {wishThatText && (
            <Editor editorState={EditorState.createWithContent(ContentState.createFromText(wishThatText))} readOnly />
          )}
          {wishThatVideo && (
            <VideoPlayer
              videoID={wishThatVideo.id}
              sources={[wishThatVideo.mp4Url, wishThatVideo.url]}
              previewImageURL={wishThatVideo.previewImageUrl}
              transcription={wishThatVideo.transcription}
              audioOnly={wishThatVideo.audioOnly}
            />
          )}
        </div>
      ) : null}
    </div>
  );
}

export default FeedbackContent;
